import { render, staticRenderFns } from "./FaqSection.vue?vue&type=template&id=15ad8b5b&scoped=true"
import script from "./FaqSection.vue?vue&type=script&lang=js"
export * from "./FaqSection.vue?vue&type=script&lang=js"
import style0 from "./FaqSection.vue?vue&type=style&index=0&id=15ad8b5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad8b5b",
  null
  
)

export default component.exports